import { TrashCalendarApiTrashCalendarUpdateRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useTrashCalendarUpdateMutation = () =>
  useBaseMutation({
    mutationFn: (req: TrashCalendarApiTrashCalendarUpdateRequest, config) =>
      appApiClient.trashCalendarApi.trashCalendarUpdate(req, config),
  });
